import { render, staticRenderFns } from "./Deliveries-Tab-By-Driver.vue?vue&type=template&id=a2772dc8"
import script from "./Deliveries-Tab-By-Driver.vue?vue&type=script&lang=js"
export * from "./Deliveries-Tab-By-Driver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports